import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LanguageService } from 'src/app/services/account/language.service';
import { EvSwitchComponent } from '../../../ui-components/ev-switch/ev-switch.component';
import { ModalOptionPanelComponent } from '../../modal-option-panel/modal-option-panel.component';

@Component({
  standalone: true,
  selector: 'app-routing-options',
  templateUrl: './routing-options.component.html',
  styleUrls: ['./routing-options.component.scss'],
  imports: [CommonModule, EvSwitchComponent, ModalOptionPanelComponent]
})
export class RoutingOptionsComponent {
  // Switch state is owned by the dialog (VehicleOptionsDialogComponent), so it
  // survives tab switches and is only persisted/applied when the user clicks OK.
  @Input() tollRoad: number = 1;
  @Output() tollRoadChange = new EventEmitter<number>();

  @Input() ferries: number = 1;
  @Output() ferriesChange = new EventEmitter<number>();

  @Input() highways: number = 1;
  @Output() highwaysChange = new EventEmitter<number>();

  @Input() tripRecording: number = 1;
  @Output() tripRecordingChange = new EventEmitter<number>();

  constructor(public languageService: LanguageService) {}
}
